import { API } from "../store"

export const toggleMessageDrawer = (open = true) => ({
  type: "MESSAGE_DRAWER::TOGGLE",
  open,
})

export const setActiveChatter = activeChatter => ({
  type: "MESSAGE_DRAWER::ACTIVE_CHATTER::SET",
  activeChatter,
})

export const setChatRead = userId => ({
  type: "MESSAGE_DRAWER::ACTIVE_CHATTER::SET_READ",
  userId,
})

export const removeChatter = userId => ({
  type: "MESSAGE_DRAWER::ACTIVE_CHATTER::REMOVE",
  userId,
})

export const clearChatters = () => ({
  type: "MESSAGE_DRAWER::CLEAR",
})

export const setVisibility = (visible = 0) => ({
  type: "MESSAGE_DRAWER::VISIBILITY::SET",
  visible,
})

export const loadingMessages = (userId, loading = true) => ({
  type: "MESSAGE_DRAWER::MESSAGES::SET_LOADING",
  userId,
  loading,
})

export const setMessages = (userId, messages) => ({
  type: "MESSAGE_DRAWER::MESSAGES::SET",
  userId,
  messages,
})

export const pushMessage = (userId, message) => ({
  type: "MESSAGE_DRAWER::MESSAGES::PUSH",
  userId,
  message,
})

export const setActiveChatterRating = (userId, rating, avgRating) => ({
  type: "MESSAGE_DRAWER::ACTIVE_CHATTER::RATING::SET",
  userId,
  rating,
  avgRating,
})

export const getMessages = (userId, companyId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        dispatch(loadingMessages(userId, true))
        API.post(`/sms/list`)
          .send({
            user_id: userId,
            company_id: companyId,
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "sms messages found") {
              dispatch(setMessages(userId, response.data))
              resolve(response.data)
            } else {
              dispatch(loadingMessages(userId, false))
              reject(response.error)
            }
          })
          .catch(err => {
            reject(err)
            dispatch(loadingMessages(userId, false))
          })
      }
      call()
    })
    return deferred
  }
}

export const sendMessage = (userId, companyId, message) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/sms`)
          .send({
            user_id: userId,
            company_id: companyId,
            message: message,
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "sms created") {
              dispatch(pushMessage(userId, response.data))
              resolve(response.data)
            } else {
              reject(response.error)
            }
          })
      }
      call()
    })
    return deferred
  }
}
